var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSenseLogo = function SvgSenseLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    width: 122,
    height: 30,
    "data-name": "Layer 1",
    viewBox: "0 0 371.39 91.3"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sense-logo-cls-2{fill:#113}"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.48 63.26c3.5 0 6-.4 7.6-1.3a4.44 4.44 0 0 0 2.4-4.3 5.6 5.6 0 0 0-2.6-4.7 36.8 36.8 0 0 0-8.4-4 69 69 0 0 1-6.6-2.8 24.6 24.6 0 0 1-5.2-3.4 13.2 13.2 0 0 1-3.4-4.7 17.2 17.2 0 0 1-1.3-6.8c0-5.2 1.9-9.4 5.8-12.4s9.1-4.5 15.7-4.5a50.4 50.4 0 0 1 9.6.9 44 44 0 0 1 6.9 1.8l-2.4 10.71a26.4 26.4 0 0 0-5.6-1.8 36.7 36.7 0 0 0-7.8-.8 13.34 13.34 0 0 0-6.5 1.4 4.41 4.41 0 0 0-2.5 4.2 6.6 6.6 0 0 0 .5 2.5 5.2 5.2 0 0 0 1.7 2 27 27 0 0 0 3.2 1.9 40 40 0 0 0 4.8 1.9c3.1 1.2 5.8 2.3 8 3.4a20.7 20.7 0 0 1 5.4 3.8 12.4 12.4 0 0 1 3.1 4.8 18.1 18.1 0 0 1 1 6.5c0 5.5-2 9.6-6 12.4s-9.8 4.2-17.3 4.2a44.6 44.6 0 0 1-12.1-1.3 51 51 0 0 1-6.4-2l2.3-11a58 58 0 0 0 7 2.3 30.6 30.6 0 0 0 9.1 1.09M150.68 44.56a35.8 35.8 0 0 1 2.2-13.2 28.5 28.5 0 0 1 5.9-9.4 25.4 25.4 0 0 1 8.5-5.7 25.9 25.9 0 0 1 9.8-1.9c7.8 0 14 2.4 18.4 7.3s6.6 12.1 6.6 21.8a24 24 0 0 1-.1 2.5 19.5 19.5 0 0 1-.2 2.5h-37.6c.4 4.6 2 8.1 4.9 10.6s7 3.8 12.5 3.8a40.3 40.3 0 0 0 8.8-.9 34.5 34.5 0 0 0 6.3-1.9l1.7 10.8a16.2 16.2 0 0 1-3 1.1 35 35 0 0 1-4.4 1.1c-1.6.3-3.4.6-5.3.8a55 55 0 0 1-5.8.3 34.9 34.9 0 0 1-13.1-2.2 25.3 25.3 0 0 1-9.2-6.2 25 25 0 0 1-5.3-9.4 43.7 43.7 0 0 1-1.6-11.8m38.2-5.9a18.2 18.2 0 0 0-.8-5.2 14.5 14.5 0 0 0-2.2-4.3 11 11 0 0 0-3.6-2.8 11.3 11.3 0 0 0-5.1-1 12.5 12.5 0 0 0-5.3 1.1 14.5 14.5 0 0 0-3.9 3 13.1 13.1 0 0 0-2.5 4.3 20.7 20.7 0 0 0-1.2 4.9ZM213.88 17.56q3.75-1 9.9-2.1a80.7 80.7 0 0 1 13.5-1 31.2 31.2 0 0 1 11.7 1.9 19.9 19.9 0 0 1 7.5 5.3 19.35 19.35 0 0 1 3.9 8.3 44.2 44.2 0 0 1 1.1 10.6v32h-13.2v-30a43.4 43.4 0 0 0-.6-7.8 13.8 13.8 0 0 0-2-5.2 7.68 7.68 0 0 0-3.7-2.9 16.2 16.2 0 0 0-5.7-.9 47 47 0 0 0-5.2.3c-1.8.2-3.2.4-4 .5v46h-13.2ZM289.79 63.26c3.5 0 6-.4 7.6-1.3a4.44 4.44 0 0 0 2.4-4.3 5.6 5.6 0 0 0-2.6-4.7 36.8 36.8 0 0 0-8.4-4 69 69 0 0 1-6.6-2.8 24.6 24.6 0 0 1-5.2-3.4 13.2 13.2 0 0 1-3.4-4.7 17.2 17.2 0 0 1-1.3-6.8c0-5.2 1.9-9.4 5.8-12.4s9.1-4.5 15.7-4.5a50.4 50.4 0 0 1 9.6.9 44 44 0 0 1 6.9 1.8l-2.41 10.71a26.4 26.4 0 0 0-5.6-1.8 36.7 36.7 0 0 0-7.8-.8 13.34 13.34 0 0 0-6.5 1.4 4.41 4.41 0 0 0-2.5 4.2 6.6 6.6 0 0 0 .5 2.5 5.2 5.2 0 0 0 1.7 2 27 27 0 0 0 3.2 1.9 40 40 0 0 0 4.8 1.9c3.1 1.2 5.8 2.3 8 3.4a20.7 20.7 0 0 1 5.4 3.8 12.4 12.4 0 0 1 3.1 4.8 18.1 18.1 0 0 1 1 6.5c0 5.5-2 9.6-6 12.4s-9.8 4.2-17.3 4.2a44.6 44.6 0 0 1-12.1-1.3 51 51 0 0 1-6.4-2l2.3-11a58 58 0 0 0 7 2.3 30.6 30.6 0 0 0 9.11 1.09M319.98 44.56a35.8 35.8 0 0 1 2.2-13.2 28.5 28.5 0 0 1 5.9-9.4 25.4 25.4 0 0 1 8.5-5.7 25.9 25.9 0 0 1 9.8-1.9c7.8 0 14 2.4 18.4 7.3s6.6 12.1 6.6 21.8a24 24 0 0 1-.1 2.5 19.5 19.5 0 0 1-.2 2.5h-37.6c.4 4.6 2 8.1 4.9 10.6s7 3.8 12.5 3.8a40.3 40.3 0 0 0 8.8-.9 34.5 34.5 0 0 0 6.3-1.9l1.7 10.8a16.2 16.2 0 0 1-3 1.1 35 35 0 0 1-4.4 1.1c-1.7.3-3.4.6-5.3.8a55 55 0 0 1-5.8.3 34.9 34.9 0 0 1-13.1-2.2 25.3 25.3 0 0 1-9.2-6.2 25 25 0 0 1-5.3-9.4 40.1 40.1 0 0 1-1.6-11.8m38.2-5.9a18.2 18.2 0 0 0-.8-5.2 14.5 14.5 0 0 0-2.2-4.3 11 11 0 0 0-3.6-2.8 11.3 11.3 0 0 0-5.1-1 12.5 12.5 0 0 0-5.3 1.1 14.5 14.5 0 0 0-3.9 3 13.1 13.1 0 0 0-2.49 4.31 20.7 20.7 0 0 0-1.2 4.9Z",
    className: "sense-logo-cls-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    cx: 12.1,
    cy: 36.4,
    r: 12.1,
    "data-name": "Ellipse 202",
    style: {
      fill: "#ffd252"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    cx: 48,
    cy: 12.1,
    r: 12.1,
    "data-name": "Ellipse 205",
    style: {
      fill: "#f05a28"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    cx: 12.1,
    cy: 79.2,
    r: 12.1,
    "data-name": "Ellipse 204",
    style: {
      fill: "#7461e5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    cx: 48,
    cy: 55,
    r: 12.1,
    "data-name": "Ellipse 206",
    style: {
      fill: "#33a30f"
    }
  }))));
};
export default SvgSenseLogo;